export default __webpack_public_path__ + "static/media/miscellaneous.57637457.png";